import React from "react";

interface IProps {
	className?: string;
	color: string;
}

export const Diploma = ({ className, color }: IProps) => {
	return (
		<svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0)">
				<path
					d="M11.25 17.25H0.75V0.75H23.25V5.25"
					stroke={color ?? "#A6A1A1"}
					strokeWidth="2.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M0.75 9.75L8.25 17.25" stroke={color ?? "#A6A1A1"} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M15.75 0.75L20.25 5.25" stroke={color ?? "#A6A1A1"} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M16.237 16.483L15.437 22.362C15.4084 22.5194 15.4309 22.6817 15.501 22.8254C15.5712 22.9691 15.6853 23.0867 15.8269 23.161C15.9685 23.2353 16.1301 23.2625 16.2882 23.2386C16.4463 23.2146 16.5927 23.1409 16.706 23.028L18.755 20.978L20.804 23.028C20.9173 23.1409 21.0636 23.2146 21.2217 23.2386C21.3798 23.2625 21.5414 23.2353 21.683 23.161C21.8246 23.0867 21.9388 22.9691 22.0089 22.8254C22.0791 22.6817 22.1015 22.5194 22.073 22.362L21.273 16.483"
					stroke={color ?? "#A6A1A1"}
					strokeWidth="2.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M14.25 12.75C14.25 13.3409 14.3664 13.9261 14.5925 14.4721C14.8187 15.018 15.1502 15.5141 15.568 15.932C15.9859 16.3498 16.482 16.6813 17.0279 16.9075C17.5739 17.1336 18.1591 17.25 18.75 17.25C19.3409 17.25 19.9261 17.1336 20.4721 16.9075C21.018 16.6813 21.5141 16.3498 21.932 15.932C22.3498 15.5141 22.6813 15.018 22.9075 14.4721C23.1336 13.9261 23.25 13.3409 23.25 12.75C23.25 12.1591 23.1336 11.5739 22.9075 11.0279C22.6813 10.482 22.3498 9.98588 21.932 9.56802C21.5141 9.15016 21.018 8.81869 20.4721 8.59254C19.9261 8.3664 19.3409 8.25 18.75 8.25C18.1591 8.25 17.5739 8.3664 17.0279 8.59254C16.482 8.81869 15.9859 9.15016 15.568 9.56802C15.1502 9.98588 14.8187 10.482 14.5925 11.0279C14.3664 11.5739 14.25 12.1591 14.25 12.75V12.75Z"
					stroke={color ?? "#A6A1A1"}
					strokeWidth="2.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M0.75 8.25L8.25 0.75" stroke={color ?? "#A6A1A1"} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M18.75 11.525C18.5077 11.525 18.2709 11.5969 18.0695 11.7315C17.868 11.8661 17.711 12.0574 17.6183 12.2812C17.5256 12.5051 17.5013 12.7514 17.5486 12.989C17.5958 13.2266 17.7125 13.4449 17.8838 13.6162C18.0551 13.7876 18.2734 13.9042 18.511 13.9515C18.7487 13.9988 18.995 13.9745 19.2188 13.8818C19.4427 13.7891 19.634 13.632 19.7686 13.4306C19.9032 13.2291 19.975 12.9923 19.975 12.75C19.975 12.4251 19.846 12.1136 19.6162 11.8838C19.3865 11.6541 19.0749 11.525 18.75 11.525Z"
					fill="#A6A1A1"
				/>
			</g>
			<defs>
				<clipPath id="clip0">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
